.TooltipContent {
  position: fixed;
  z-index: 50;
  max-width: 200px;
  width: fit-content;
  box-shadow: var(--smooth-shadow);
  border-radius: 4px;
  border: 1px solid transparent;
  background-color: var(--primary);
  padding: var(--space-sm);
  color: var(--white);
  font-size: 14px;
  word-break: break-word;

  &[data-state="open"],
  &[data-state="open"] + .TooltipArrow {
    animation: fade-in 100ms ease-in-out forwards;
  }

  &[data-state="closed"],
  &[data-state="closed"] + .TooltipArrow {
    animation: fade-out 100ms ease-in-out forwards;
  }

  &.info {
    border-color: var(--neutral);
    background-color: var(--white);
    color: var(--black);
  }

  &.error {
    border-color: var(--accent-2);
    color: var(--accent-2);
    background-color: var(--white);
  }

  &.warning {
    border-color: var(--accent-1);
    background-color: var(--white);
    color: var(--black);
  }
}

.TooltipTrigger:focus-visible {
  outline-offset: 2px;
}

@keyframes fade-in {
  from {
    opacity: 0;
    scale: 0.95;
    transform: var(--animation-transform);
  }

  to {
    opacity: 1;
    scale: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
    scale: 1;
  }

  to {
    opacity: 0;
    scale: 0.95;
    transform: var(--animation-transform);
  }
}
